<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Cards</span>
            <small></small>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="3" v-if="is_admin === true">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompnay($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                </b-form-group>
              </b-col>
              <!-- <b-col sm="3">
              <b-form-group>
                  <label for="name">From Date</label><br />
                  <date-picker
                    v-model="fromdate"
                    editable
                    lang="en"
                  ></date-picker>
                </b-form-group>
              </b-col>   -->

              <!-- <b-col sm="3">
                <b-form-group>
                  <label for="name">To Date </label><br />
                  <date-picker
                    v-model="todate"
                    editable
                    lang="en"
                  ></date-picker>
                </b-form-group>
              </b-col> -->
              <b-col sm="3">
                <b-form-group >
                  <label for="name">Customer Name : </label>
                   <!-- <input type="text" class="form-control" v-model="search.custname" id="custname" name="custname" autocomplete="off" placeholder="Enter Customer Name"> -->
                    <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="selectedcustomer" placeholder="Search Customer Name" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                  </b-form-group>
              </b-col> 
               <b-col sm="2">
                <b-form-group>
                  <label for="name">Month</label><br />
                  <model-list-select :list="monthlist" option-value="name" :custom-text="monthName" v-model="openingmonth" placeholder="Select Month"  @searchchange="searchmonths" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                </b-form-group>
              </b-col>
                <!-- <b-col sm="3">
                <b-form-group >
                  <label for="name">Year : </label>
                    <model-list-select :list="yearlist" option-value="name"  v-model="selectedyear" placeholder="Search Customer Name" @searchchange="searchyear" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                  </b-form-group>
              </b-col>  -->
              <b-col sm="2">
                <b-form-group>
                  <label for="name">Year : </label><br />
                  <b-form-input
                    type="text" :class="{'is-invalid':hasErrors.year}" autocomplete="off"
                    placeholder="Enter Year"
                    v-model="selectedyear"
                  ></b-form-input>
                  <small class="form-text text-muted" v-if="hasErrors.year" ><strong style="color: red;" >Enter Valid Full Year</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label for="name">Ledger No</label><br />
                  <b-form-input
                    type="text"
                    placeholder="Enter Ledger No"
                    v-model="search.ledgerno"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <button
                    type="button"
                    v-if="pur_view === true"
                    style="margin-top: 24px; margin-left: 16%;"
                    class="btn btn-pill btn-primary serach_bttn"
                    @click="searchpurchase"
                  >
                    <i class="fa fa-search"></i>&nbsp;Search
                  </button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> List Close Cards ( Total Dues Pending : {{ totalAmt }}) 
                  <!-- <a href="#/createcard" v-if="pur_rights === true"
                    ><button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                    >
                      <i class="fa fa-plus"></i> Create Card
                    </button></a> -->
                </div>
                <!-- <div class="col-sm-8"> 
                  </div> -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
                <!-- <div class="col-sm-1">
                  <button
                    id="MyDownload"
                    type="button"
                    v-if="pur_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class=""></i> Export Data
                  </button>
                </div> -->
              </div>
            </div>
            <!-- <span class="title_head"
              >List Purchase
              <span
                >&nbsp;&nbsp;
                <a href="#/Purchase/AddPurches" v-if="pur_rights === true"
                  ><button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                  >
                    <i class="fa fa-plus"></i> Add Purchase
                  </button></a
                >
              </span>
              <span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button  id = 'MyDownload'
                   type="button"
                    v-if="pur_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class="fa fa-plus"></i> Export Data
                    
                  </button>
              </span>
            </span> -->
          </div>
          <div class="card-body">
            <vue-good-table
              mode="remote"
              ref="my-table"
              :columns="columns4"
              :rows="rows4"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                   <span v-if="props.column.field == 'action'">

                   </span>
                   <span v-else-if="props.column.field == 'closing_date'">
                  {{ newDate(props.row.closing_date) }}
                </span>
                  <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
             
                
                
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Card detail "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>

            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>

    <b-modal
      title="Select Purchase Items To Return "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal1"
      @ok="warningModal1 = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns2"
          :rows="rows2"
          :select-options="{
            enabled: true,
          }"
          mode="remote"
          ref="my-table2"
          @on-page-change="onPageChange2"
          @on-sort-change="onSortChange2"
          @on-column-filter="onColumnFilter2"
          @on-per-page-change="onPerPageChange2"
          :totalRows="totalRecords2"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>

            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
      <button
        v-if="pur_rights === true"
        type="button"
        class="btn btn-sm btn-primary label_bttn"
        @click="returnitems"
      >
        Proceed
      </button>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  name: "Cardlist",
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    var today = new Date();
    return {
      totalAmt:0,
      customername:[],
      companylist: [],
      yearlist:[{}],
      selectcompany: null,
      pfrst_time: false,
      shpfrst_time: false,
      openingmonth:'',
      productunit: "",
      search:{
        ledgerno:'',
        custname :'',
      },
      selectedcustomer:'',
      selectedyear:'',
      productqty: "",
      rows: [],
      hasErrors:{
        year:false,
      },
      rows1: [],
      rows2: [],
      rows4: [],
      todate: "",
      fromdate: "",
      temprow: null,
      warningModal: false,
      warningModal1: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "purchase_id",
          type: "asc",
        },
        page: 1,
        perPage: 5,
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      totalRecords1: 0,
      totalRecords2: 0,
       columns4: [
        // {
        //   label: "Card Id",
        //   field: "id",
        //   width: "10% !important",
        //   thClass: "text-center",
        // },
        {
          label: "Customer Name",
          field: "cust_cmp_name",
          width: "5% !important",
          thClass: "text-left",
        },
        {
          label: "Shop Name",
          field: "est_shop_name",
          width: "5% !important",
          thClass: "text-left",
        }, 
        {
          label: "Ledger No",
          field: "ledger_no",
          width: "5% !important",
          thClass: "text-left",
        },
        {
          label: "Month",
          field: "pay_month",
          width: "5% !important",
          thClass: "text-left",
        },      
          {
          label: "Card Amount",
          field: "monthly_pay",
          width: "10% !important",
          thClass: "text-left",
        },
      
        
        // {
        //   label: "Return",
        //   field: "return",
        //   width: "5% !important",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
      columns1: [
        {
          label: "Product Name",
          field: "product_name",
          width: "25% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "15% !important",
        },
        {
          label: "Qty",
          field: "purchase_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "8% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Barcode",
          field: "item_barcode",
          width: "32% !important",
        },
      ],

      columns2: [
        {
          label: "Product Name",
          field: "product_name",
          width: "25% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "15% !important",
        },
        {
          label: "Qty",
          field: "purchase_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "8% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Return Qty",
          field: "return_qty",
          width: "15% !important",
        },
        {
          label: "Barcode",
          field: "item_barcode",
          width: "32% !important",
        },
      ],

       columns: [
        {
          label: "Card Id",
          field: "id",
          width: "10% !important",
          thClass: "text-center",
        },
        {
          label: "Ledger No",
          field: "ledger_no",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Monthly Pay",
          field: "monthly_pay",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Opening Month",
          field: "opening_month",
          width: "15% !important",
          thClass: "text-center",
        },
        
        {
          label: "Date",
          field: "lastupdated_datetime",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-center",
          width: "15% !important",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "Return",
        //   field: "return",
        //   width: "5% !important",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
    };
  },
  created(){
    //this.customerCards();
     this.searchcustomer();
     this.getTotals();
     this.searchmonths();
  },
  computed: {
    
    pur_view: function () {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_pur_view === true) {
          this.purchase("comp");
          this.shopuser("comp");
          
          
          return true;
        } else {
          return false;
        }
      }
    },
    pur_rights: function () {
      return this.$store.getters.get_pur_rights;
    },
    is_admin: function () {
      return this.$store.getters.get_is_admin;
    },
  },

  // created(){
  //       this.purchase();
  //       this.shopuser();
  //   },

  methods: {
       searchmonths(){
       var _this = this
          var myObj =[
	{
    "id":"1",
		"abbreviation": "Jan",
		"name": "January"
	},
	{
    "id":"2",
		"abbreviation": "Feb",
		"name": "February"
	},
	{
    "id":"3",
		"abbreviation": "Mar",
		"name": "March"
	},
	{
    "id":"4",
		"abbreviation": "Apr",
		"name": "April"
	},
	{
    "id":"5",
		"abbreviation": "May",
		"name": "May"
	},
	{
    "id":"6",
		"abbreviation": "Jun",
		"name": "June"
	},
	{
    "id":"7",
		"abbreviation": "Jul",
		"name": "July"
	},
	{
    "id":"8",
		"abbreviation": "Aug",
		"name": "August"
	},
	{
    "id":"9",
		"abbreviation": "Sep",
		"name": "September"
	},
	{
    "id":"10",
		"abbreviation": "Oct",
		"name": "October"
	},
	{
    "id":"11",
		"abbreviation": "Nov",
		"name": "November"
	},
	{
    "id":"12",
		"abbreviation": "Dec",
		"name": "December"
	}
];
_this.monthlist= myObj
        },
         monthName(item)
      {
        //  console.log('month return')
        // console.log(item)
          return `${item.name}`
      },
     searchcustomer(){
        var _this = this
        this.$http.get('/api/customers').then(function (response) {
          _this.customername = response.data
        }).catch(function (error) {
        });
      },
      nameAndnumber (item) {
        return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`
      },
      searchpurchase() {
      this.updateParams({
        sort: {
          type: "",
          field: "",
        },
        page: 1,
      });
      this.$refs["my-table"].reset();
      this.hasErrors.year = false;
      var submit_true = 0;
      var pirex=/^[0-9]{4}$/

      if(this.selectedyear != null && this.selectedyear != '') {
         if( pirex.test(this.selectedyear)==false){
           console.log('isske andar')
          this.hasErrors.year=true;
            submit_true=1
        }
      }
      
     if(submit_true == 0){
        this.getTotals();
     }
     
    },
    editCard(row){
      localStorage.removeItem('card_id');
       localStorage.setItem("card_id", JSON.stringify(row.id));
            this.$router.push("/editcard");
    },
     viewCard(row) {
       
      this.rows.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      //this.warningModal = true;
      var _this = this;
      this.temprow = row;
      // var data =[]
      var data = "&filter[where][card_id]=" + row.id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/customercards/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {

          if (response.data == null) {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            alert(
              "Card id - " +
                row.id +
                " No Detail Found"
            );
          } else {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            _this.$router.props = [row.id];
            localStorage.setItem("card_id", JSON.stringify(row.id));
            _this.$router.push("/gold/carddetail");
          }
        });
    },
    newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;
      // var dt2 = year+'-'+month+'-'+day
      return dt2;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      // this.loadItems();
       this.getTotals();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      // this.loadItems();
       this.getTotals();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      // this.loadItems();
       this.getTotals();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      // this.loadItems();
       this.getTotals();
    },
    getTotals(val){    
            if(val === 'comp'){
                if(this.tfrst_time === false){
                  this.tfrst_time = true
                }
                else{
                  return
                }
              }
            var _this=this
            localStorage.removeItem("customer_id");
            let filteParam = {};
            filteParam.page = this.serverParams.page;
            filteParam.perPage = this.serverParams.perPage;
            filteParam.sort = this.serverParams.sort;
            var data=[];
            this.rows=[];
            this.loading = true
            var customer_id = JSON.parse(localStorage.getItem('customer_id'));
             var custname = this.selectedcustomer
             var searchmonth = this.openingmonth
             var flag = '0';
              if(this.selectedcustomer =='' && this.search.ledgerno =='' && this.openingmonth=='' && this.selectedyear=='' ){
                  var data = "&filter[where][cusid]=" + flag;
              }
              
              
             if(this.selectedcustomer!=''){
                // data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
                 var data = data+"&filter[where][customer_id]=" + custname;
              }
             if (this.search.ledgerno) {
                 data = data + "&filter[where][ledger_no]=" + this.search.ledgerno;
                //  console.log(data)
            }
              if(this.openingmonth!=''){
                // data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
                 var data = data+"&filter[where][pay_month]=" + searchmonth;
              }
              if(this.selectedyear!=''){
                // data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
                 var data = data+"&filter[where][pay_year]=" + this.selectedyear;
                //  console.log(data)
              }
            // console.log(JSON.stringify(filteParam)+data)
            var total = 0;
            this.$http.get('/api/customermonthentries/showCards?params='+JSON.stringify(filteParam)+data)
                    .then(function(response){
                      _this.totalRecords = response.data[0].totalRecords;
                      response.data.shift()
                      if(response.data != undefined)
                       for (var i = 0; i < response.data.length; i++) {
                         total += parseFloat(response.data[i].monthly_pay)
                       }
                      _this.totalAmt=total;
                      _this.rows4=  response.data;
                      _this.loading = false
                      // console.log(response.data)
                   
                      }).catch(function(error){
                  console.log(error)
              })
            },
    updateParams1(newProps) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.editpro(this.temprow);
    },

    onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.editpro(this.temprow);
    },

    onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field,
        },
        page: 1,
      });
      this.editpro(this.temprow);
    },

    onColumnFilter1(params) {
      this.updateParams1(params);
      this.editpro(this.temprow);
    },
    updateParams2(newProps) {
      this.serverParams2 = Object.assign({}, this.serverParams2, newProps);
    },

    onPageChange2(params) {
      this.updateParams2({ page: params.currentPage });
      this.editpro2(this.temprow);
    },

    onPerPageChange2(params) {
      this.updateParams2({ perPage: params.currentPerPage, page: 1 });
      this.editpro2(this.temprow);
    },

    onSortChange2(params) {
      this.updateParams2({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field,
        },
        page: 1,
      });
      this.editpro2(this.temprow);
    },

    onColumnFilter2(params) {
      this.updateParams2(params);
      this.editpro2(this.temprow);
    },
    removeCard(cardid){
            var r = confirm("Are you sure you want to delete?");
            if (r == true) {
              this.loading=true
              var _this=this
              var _vm = this.errorMessage
              var id =cardid.id;
              this.$http.delete('/api/customercards/'+id).then(function (response) {
                _this.loading=false
               // _vm.message = "Scheme Deleted Successfully"
                setTimeout(function(){ _vm.message='';}, 2000);
               _this.getTotals();
                  //_this.customerCards();
                  
              })
              .catch(function (error) {
                _this.loading=false
                console.log(error);
              });
            }
          },

    // editPurchase(row){
    //    var _this = this
    //    var filteParam = {};
    //    filteParam.pid = this.row.purchase_id;
    //    filteParam.sid = this.row.est_shop_id;

    // },

    // load items is what brings back the rows from server
    returnitems() {
      var purchase_id = this.$refs["my-table2"].selectedRows[0]["purchase_id"];
      var est_shop_id = this.$refs["my-table2"].selectedRows[0]["est_shop_id"];

      if (this.$refs["my-table2"].selectedRows.length > 0) {
        // console.log(this.$refs['my-table2'].selectedRows)
        if ("purchase_return_id" in this.$refs["my-table2"].selectedRows[0]) {
          var item_seqs = {};
          for (
            var i = 0;
            i < this.$refs["my-table2"].selectedRows.length;
            i++
          ) {
            item_seqs[
              this.$refs["my-table2"].selectedRows[i].item_seq_no
            ] = this.$refs["my-table2"].selectedRows[i].purchase_qty;
          }
          // console.log({'purchaseId': purchase_id, 'shopId': est_shop_id, 'itemSeqs': JSON.stringify(item_seqs), 'purchaseReturnId': this.$refs['my-table2'].selectedRows[0]['purchase_return_id']})
          this.$router.push({
            name: "Edit Purchase Return",
            params: {
              purchaseId: purchase_id,
              shopId: est_shop_id,
              itemSeqs: JSON.stringify(item_seqs),
              purchaseReturnId: this.$refs["my-table2"].selectedRows[0][
                "purchase_return_id"
              ],
            },
          });
        } else {
          var item_seqs = [];
          for (
            var i = 0;
            i < this.$refs["my-table2"].selectedRows.length;
            i++
          ) {
            item_seqs.push(this.$refs["my-table2"].selectedRows[i].item_seq_no);
          }

          this.$router.push({
            name: "Add Purchase return",
            params: {
              purchaseId: purchase_id,
              shopId: est_shop_id,
              itemSeqs: item_seqs,
            },
          });
        }
      } else {
        return;
      }
    },

    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function (response) {
          // console.log(response)
          _this.companylist = response.data;
        })
        .catch(function (error) {});
    },

    onSelectCompnay(selected_company) {
      this.loadItems();
    },

    loadItems() {
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;

      if (this.todate && this.fromdate) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]= " +
          fromdate1 +
          "  &filter[where][lastupdated_datetime][between][1]= " +
          todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
    
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }

      this.$http
        .get(
          "/api/purchasedetails/getPurchase?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
          // console.log(_this.rows)
        })
        .catch(function (error) {
          console.log(error);
          _this.loading = false;
        });
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },

    purchase(val) {
      if (val === "comp") {
        if (this.pfrst_time === false) {
          this.pfrst_time = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
     customerCards(){
       var _this=this
         var filteParam = {};
      //  filteParam.page = this.serverParams2.page;
      // filteParam.perPage = this.serverParams2.perPage;
      // filteParam.sort = this.serverParams2.sort;
         this.customer_id = JSON.parse(localStorage.getItem('customer_id'));
      // this.$http.get('/api/customermonthentries/CustomerCards')
    
       var data = "&filter[where][customer_id]=" + this.customer_id;
      this.$http
        .get(
          "/api/customercards/allCards?params=" +
            JSON.stringify(filteParam) +
            data
        ).then(function (response) {
        _this.rows4 =response.data
      
      })
      .catch(function (error) {

      });
      //console.log("Card Entery Detail");
    },
    
   
    //Nishith Changes For Excel Report
    exportData() {
      // alert('data')
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;
      var custname = this.selectedcustomer
      if (this.todate && this.fromdate) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]= " +
          fromdate1 +
          "  &filter[where][lastupdated_datetime][between][1]= " +
          todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
       if(this.selectedcustomer!=''){
                // data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
                 var data = data+"&filter[where][customer_id]=" + custname;
              }
      if (this.search.ledgerno) {
        data = data + "&filter[where][ledger_no]=" + this.search.ledgerno;
      }
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      if(this.rows4.length > 0 ){

      this.$http
        .get(
          "/api/goldpurchases/getCustomerCardExport?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          // console.log(response)

          var access_token = localStorage.getItem("authUser");
          //  console.log(response.data)
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          _this.loading = false;
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
              _this.loading = false;
            });
          ///End OF Exce Downlod Method...
        });
      } else {
        _this.loading = false;
        alert('No Data Found')
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/gold/custduelist.vue